import Fraction from 'fraction.js';
import { quotation } from './quotation';
import { toNearest } from '../util';

const toFraction = (x) => new Fraction(toNearest(0.0625)(x)).toFraction(true);
const SIDE_FRAME = 1.5;
const LITE_INSET = 5.5;
const QUOTATION_STEP = 10;

const isStrictlyIncreasing = (values) =>
  values.every((value, index) => index === 0 || value > values[index - 1]);

export const storefront = ({ two, widths, elevations }) => {
  two.clear();

  const bayWidths = widths.filter((width) => width > 0);
  const liteElevations = elevations.filter((height) => height > 0);

  if (
    bayWidths.length === 0 ||
    liteElevations.length === 0 ||
    !isStrictlyIncreasing(liteElevations)
  ) {
    two.update();
    return [-20, -20, 40, 40];
  }

  const totalWidth = bayWidths.reduce((sum, width) => sum + width, 0);
  const totalHeight = liteElevations[liteElevations.length - 1];
  const rowBreaks = liteElevations.slice(0, -1);
  const shapes = [];

  shapes.push(
    two.makeRectangle(totalWidth / 2, totalHeight / 2, totalWidth, totalHeight)
  );
  shapes.push(two.makePath(SIDE_FRAME, 0, SIDE_FRAME, totalHeight));
  shapes.push(
    two.makePath(totalWidth - SIDE_FRAME, 0, totalWidth - SIDE_FRAME, totalHeight)
  );

  let x = 0;
  bayWidths.forEach((width, index) => {
    const left = x;
    const right = x + width;
    const innerLeft = index === 0 ? left + SIDE_FRAME : left + SIDE_FRAME / 2;
    const innerRight =
      index === bayWidths.length - 1 ? right - SIDE_FRAME : right - SIDE_FRAME / 2;

    if (index < bayWidths.length - 1) {
      shapes.push(
        two.makePath(right - SIDE_FRAME / 2, 0, right - SIDE_FRAME / 2, totalHeight)
      );
      shapes.push(
        two.makePath(right + SIDE_FRAME / 2, 0, right + SIDE_FRAME / 2, totalHeight)
      );
    }

    shapes.push(two.makePath(innerLeft, LITE_INSET, innerRight, LITE_INSET));
    shapes.push(
      two.makePath(
        innerLeft,
        totalHeight - LITE_INSET,
        innerRight,
        totalHeight - LITE_INSET
      )
    );

    rowBreaks.forEach((elevation) => {
      const y = totalHeight - elevation;

      shapes.push(
        two.makePath(
          innerLeft,
          y,
          innerRight,
          y
        )
      );
      shapes.push(
        two.makePath(
          innerLeft,
          y + SIDE_FRAME,
          innerRight,
          y + SIDE_FRAME
        )
      );
    });

    x = right;
  });

  const group = two.makeGroup(...shapes);
  group.linewidth = 0.3;

  let quoteX = 0;
  bayWidths.forEach((width) => {
    quotation({
      two,
      length: width,
      pos: 'down',
      x: quoteX,
      y: totalHeight,
      label: `${toFraction(width)}"`,
    });
    quoteX += width;
  });

  liteElevations.forEach((elevation, index) => {
    quotation({
      two,
      length: elevation,
      dir: 'vertical',
      x: 0,
      y: totalHeight - elevation,
      pos: 'up',
      separation: QUOTATION_STEP * (index + 1),
      label: `${toFraction(elevation)}"`,
    });
  });

  two.update();

  return [
    -24 - QUOTATION_STEP * liteElevations.length,
    -10,
    totalWidth + 48,
    totalHeight + 24,
  ];
};
